import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IPrecinctFormByIdRouteProps extends PropsWithChildren {
    precinctId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const PrecinctFormByIdRoute: FC<IPrecinctFormByIdRouteProps> = ({
    precinctId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const precinctIdToUse = (params.precinctId ? +params.precinctId : undefined) ?? precinctId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={precinctIdToUse}
            formDefinitionIdentifier={FormDefinitions.Precinct}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default PrecinctFormByIdRoute;
